import React, { useState, useEffect } from 'react';
import CustomLoader from "../../common/Loader";
import { getButton } from "../../../services/formService";
import { Actions } from "../../../constants/ClickEventActions";
import { Modal } from "react-bootstrap";
import FormViewer from '../FormViewer';
import {BASE_URL} from "../../../auth/authConfig";
import { getDataSources } from "../../../services/dataSourceService";
import { buttonExecuteSP } from "../../../services/formService";
import { getIdentity } from "../../common/commonFuncs";
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';
import FullScaleRandomizeViewer from './FullScaleRandomizeViewer';
import { getProjectUserRoles } from '../../../services/projectService';

function ButtonViewer({ Project_ID, Form_ID, Widget_ID,
    PrimaryKey, Widget_Color, Custom_Save, selectedInst,
    Form_SecondaryIDName, Form_SecondaryIDValue, reloadForm, closePopUpForm, disabled
 }) {
    const [loading, setLoading] = useState(true);
    const [buttonText, setButtonText] = useState('');
    const [actionId, setActionId] = useState(0);
    const [formRedirectTo, setFormRedirectTo] = useState(0);
    const [dataSourceId, setDataSourceId] = useState(0);
    const [SPName, setSPName] = useState(null);
    const [SPParameters, setSPParameters] = useState(null);
    const [saveResponse, setSaveResponse] = useState(false);
    const [reloadFormOnPopUpClose, setReloadFormOnPopUpClose] = useState(false);
    const [institutionId, setInstitutionId] = useState(selectedInst);
    const [openModal, setOpenModal] = useState(false);
    const [visibleToRoleID, setVisibleToRoleID] = useState(0)
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const getData = async () => {
            let { data } = await getButton(Widget_ID);
            let btnData = JSON.parse(data.button);
            if(btnData.length > 0) {
                setButtonText(btnData[0].Button_Text || '');
                setActionId(btnData[0].Action_ID || 0);
                setFormRedirectTo(btnData[0].Form_RedirectTo || 0);
                setDataSourceId(btnData[0].DataSource_ID || 0);
                setSPName(btnData[0].StoredProcedure_Name);
                setSPParameters(btnData[0].StoredProcedure_Parameters);
                setSaveResponse(btnData[0].Save_Response);
                setReloadFormOnPopUpClose(btnData[0].ReloadFormOnPopUpClose || false);
                setVisibleToRoleID(btnData[0].VisibleTo_Role_ID || 0)
            }

            // get institution code
            if (!selectedInst) {
                setInstitutionId(document.getElementById('userInst').value);
            }

            if (!!btnData[0].VisibleTo_Role_ID && btnData[0].VisibleTo_Role_ID > 0) {
                let { data: userRoles } = await getProjectUserRoles(Project_ID)
                if (userRoles[0].Role_List.includes(btnData[0].VisibleTo_Role_ID.toString())) {
                    setVisible(true)
                }
            }
            
        };
            
        getData()
        .then(() => setLoading(false));
    }, []);

    const handleClick = async (e) => {
        let updatedSKValue = Form_SecondaryIDValue;
        if (saveResponse) {
            updatedSKValue = await Custom_Save();
        }
        if (actionId === Actions.PopUp) {
            setOpenModal(true);
        }
        else if (actionId === Actions.RedirectTo) {
            window.location = BASE_URL+`form?form_id=${formRedirectTo}&project_id=${Project_ID}&inst_id=${institutionId}`;
        }
        else if (actionId === Actions.ExecuteSP) {
            await handleExecuteSP(updatedSKValue);
        }

        // SAE: close popup on Save and Submit button
        if (actionId === Actions.ExecuteSP && closePopUpForm) {
            closePopUpForm();
        }
    }

    const handleExecuteSP = async(SK_Value) => {
        let { data: dataSources } = await getDataSources();
        let connectionString = dataSources.find((s) => s.DataSource_ID === dataSourceId).Connection_String;

        let allParameters = [
            {
                Name: '@PK_Value',
                Value: PrimaryKey
            },
            {
                Name: '@Activity_By',
                Value: getIdentity()
            },
            {
                Name: '@Form_ID',
                Value: Form_ID
            },
            {
                Name: '@SK_Name',
                Value: Form_SecondaryIDName
            },
            {
                Name: '@SK_Value',
                Value: SK_Value
            }
        ];

        let parameters = [];
        JSON.parse(SPParameters).forEach((SP_param) => {
            let param = allParameters.find((p) => p.Name === SP_param.Name);
            if (param) {
                parameters.push(param);
            }
        });
        let { data } = await buttonExecuteSP(SPName, connectionString, parameters);

        if (data.includes("Error")) {
            toaster('error', data);
            logActivity('/formViewer', 'WIDGET_BUTTON_EXECUTE_SP_FAILED');
        } else {
            toaster('success', 'Executed stored procedure.');
            logActivity('/formViewer', 'WIDGET_BUTTON_EXECUTE_SP_SUCCESS');
        }
    }

    const handlePopUpClose = () => {
        setOpenModal(false);
        if(actionId === Actions.PopUp && reloadFormOnPopUpClose) {
            reloadForm();
        }
    }

    if (loading) {
        return <CustomLoader loading={loading} />;
    }

    if (actionId === Actions.Randomize) {
        return <FullScaleRandomizeViewer PrimaryKey={PrimaryKey} buttonText={buttonText} disabled={disabled}
                                         saveResponse={saveResponse} handleSaveResponse={Custom_Save}/>
    }

    return (
        <div>
            <button 
                className="btn btn-primary mb-2 mt-2"
                onClick={handleClick}
                disabled={disabled}
                hidden={!!visibleToRoleID && visibleToRoleID > 0 ? !visible : false}
            >
                {buttonText}
            </button>
            <Modal
                size='xxl'
                show={openModal}
                onHide={() => handlePopUpClose()}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className='container'>
                    <FormViewer
                        Form_ID={formRedirectTo} 
                        LightMode={true}
                        PrimaryKey={PrimaryKey}
                        isPopUp={true}
                        Project_ID={Project_ID}
                        PK_Name={'Participant ID'}
                        selectedInst={institutionId}
                        closePopUpForm={handlePopUpClose}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default ButtonViewer;